import { IFormField } from "@/interfaces";

interface ISortedItem {
  id: string;
  order: number;
}

export const sortRecursively = (formData: IFormField[]): ISortedItem[] => {
  let order = 0;

  const selectItems = ({
    property: { id },
    children,
  }: IFormField): ISortedItem[] => {
    const items = [
      {
        order: order++,
        id,
      },
    ];

    const flattenedChildren =
      children?.flatMap((childItem) => selectItems(childItem)) || [];

    return [...items, ...flattenedChildren];
  };

  return formData.flatMap((item) => selectItems(item));
};
